import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import EditIcon from 'transfix-icons/build/EditIcon'
import { Card } from 'transfix-ui/components/Card'
import { IconButton } from 'transfix-ui/components/IconButton'
import { ICarrierState, TCarrierStatus } from 'types/carrier'
import { openCarrierStatusModal } from 'utils/actions/carrier'
import { getNewCarrierStatus } from 'utils/carriers/getNewCarrierStatus'
import { setIcon } from 'utils/carriers/setIcon'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { IStore } from 'apps/carrier/utils/reducers'
import { CarrierStatusModal } from './CarrierStatusModal'

export const CarrierStatus = () => {
  const dispatch = useDispatch()
  const { carrierDetails, isFetching } = useSelector<IStore, ICarrierState>(
    ({ carrier }) => carrier
  )
  const isHighwayMilestoneTwoCarrierStatusEditStatusEnabled = useFeatureFlag(
    'highwayMilestoneTwoCarrierStatusEditStatus'
  )
  const isUseNewStateTagsMpEnabled = useFeatureFlag('useNewStateTagsMp')
  const { icon, stateName, status } = carrierDetails || {}
  const iconFallback = stateName && setIcon(stateName as TCarrierStatus)
  const { Icon, color } = icon || iconFallback || {}

  const editStatus = () => dispatch(openCarrierStatusModal())
  return (
    <Card>
      <div className='row no-gutter pv4'>
        <h3 className='fl mb0 mt2'>Carrier Status</h3>
        {!isHighwayMilestoneTwoCarrierStatusEditStatusEnabled && !isFetching && (
          <div className='fr'>
            <IconButton
              Icon={EditIcon}
              color='tertiary'
              onClick={editStatus}
              data-test='edit-status'
              label='Edit Carrier Status'
              size='large'
            />
          </div>
        )}
      </div>
      <p>
        {Icon && (
          <div className='ph1'>
            <Icon className={`icon-${color} inline large`} />
          </div>
        )}
        {getNewCarrierStatus(status || stateName || '', isUseNewStateTagsMpEnabled)}
      </p>
      <CarrierStatusModal />
    </Card>
  )
}
